import { Link } from "react-router-dom";
import useTheme from "../../../hooks/useTheme";
import MainLogo from "../../atoms/MainLogo/MainLogo";
import UserName from "../../atoms/UserName/UserName";
import { useContext, useState } from "react";
import GlobalVariablesContext from "../../contexts/GlobalVariablesContext";
import Cog from "../../atoms/Cog/Cog";
import "./Header.scss";
import SettingsDialog from "../SettingsDialog/SettingsDialog";

const Header = () => {

    const theme = useTheme();

    const { account } = useContext(GlobalVariablesContext);

    const [showSettingsDialog, setShowSettingsDialog] = useState(false);
    
    return (
        <div className="top-bar">
            {theme && <img className="top-bar-banner" src={process.env.PUBLIC_URL + "/banner-" + theme + ".jpg"} alt={theme} />}
            <div className={"top-bar-contents" + (theme ? ' top-bar-contents-invert' : '')}>
                <MainLogo />

                {account &&
                    <p className="account-info">
                        <UserName userName={account.userName} image={<Cog />} onClick={() => setShowSettingsDialog(true)} />
                        <br />
                        <Link to="/logout">Log out</Link>
                    </p>
                }
            </div>
            {showSettingsDialog && <SettingsDialog onClose={() => setShowSettingsDialog(false)} onCancel={() => setShowSettingsDialog(false)} />}
        </div>
    );
}

export default Header;